import { ScenarioBudget, TagRevenu } from '../types';

/**
 * Choix du statut d'un événement de revenu : définitif (tronc) ou projeté
 * (rattaché à un scénario nommé). Le tag 'consolide' est en lecture seule —
 * il sera écrit par le futur sous-module de consolidation bancaire.
 */
export function ChoixTagScenario({ tag, scenarioId, scenarios, onChange }: {
  tag: 'definitif' | 'projete';
  scenarioId: number | null;
  scenarios: ScenarioBudget[];
  onChange: (tag: 'definitif' | 'projete', scenarioId: number | null) => void;
}) {
  const actifs = scenarios.filter((s) => !s.archive);
  return (
    <div className="flex gap-8 items-center flex-wrap">
      <div className="selectable-group">
        <button
          type="button"
          className={`selectable${tag === 'definitif' ? ' active' : ''}`}
          onClick={() => onChange('definitif', null)}
          title="Décision prise — fait partie du tronc commun à tous les scénarios"
        >
          Définitif
        </button>
        <button
          type="button"
          className={`selectable${tag === 'projete' ? ' active' : ''}`}
          onClick={() => onChange('projete', scenarioId ?? actifs[0]?.id ?? null)}
          title="Hypothèse à l'étude — visible seulement dans son scénario"
        >
          Projeté
        </button>
      </div>
      {tag === 'projete' && (
        <select
          className="sort-select"
          value={scenarioId ?? ''}
          onChange={(e) => onChange('projete', Number(e.target.value) || null)}
          title="Scénario auquel rattacher cette hypothèse"
        >
          {scenarioId == null && <option value="">Choisir un scénario…</option>}
          {actifs.map((s) => <option key={s.id} value={s.id}>{s.nom}</option>)}
        </select>
      )}
    </div>
  );
}

export function BadgeTagRevenu({ tag, scenarioNom }: { tag: TagRevenu; scenarioNom?: string | null }) {
  if (tag === 'definitif') return <span className="badge badge-ok badge-sm">définitif</span>;
  if (tag === 'consolide') return <span className="badge badge-accent badge-sm" title="Vérifié contre les transactions bancaires">consolidé</span>;
  return <span className="badge badge-warn badge-sm">{scenarioNom ? `projeté · ${scenarioNom}` : 'projeté'}</span>;
}
